export default "__VITE_PUBLIC_ASSET__0505fea2__"